import { withParams } from 'vuelidate';
import { EmailValidator } from 'commons-validator-js';
import XRegExp from 'xregexp';
import { EMAIL_REGEXP } from '../constants/constants';
const emailValidator = new EmailValidator();
export default withParams({ type: 'email' }, (value) => {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}
	if (emailValidator.isValid(value) && new XRegExp(EMAIL_REGEXP).test(value)) {
		return true;
	}
	return false;
});
